export const beforeTestFAQs = [
    {
        question: 'Is the iACST open for all Classes and Streams?',
        answer: 'iACST is open for Class studying 7th, 8th, 9th 10th (SOE & SOM), 11th & 12th SOM & SOE.',
        type: 'text',
    },
    {
        question: 'What are the exam timings?',
        answer: 'Online exam from 9 AM to 10 PM. Students can enroll at any time in the exam window.',
        type: 'text',
    },
    {
        question:
            'What are the guidelines for appearing in the exam on the same day as registration?',
        type: 'text',
        answer: 'For online exam, students have to complete registration before 9 PM.',
    },
    {
        question:
            'How to update my personal details (Like dob, e-mail Id, and Address details) in IACST?',
        type: 'text',
        answer: 'You also call on IACST Toll-Free No. 8800198748 or write to <a href="mailto:acstsupport@aesl.in">acstsupport@aesl.in</a> or submit their request by filling out the Google form: <a href="https://forms.gle/EA5uzfGmKEzaeg4P8" target="_blank">https://forms.gle/EA5uzfGmKEzaeg4P8</a> to get their details changed ',
    },
    {
        question: 'How should we get the Class/Date/Stream changed for the student?',
        type: 'text',
        answer: 'You call on IACST Toll-Free No. 8800198748 or write on <a href="mailto:acstsupport@aesl.in">acstsupport@aesl.in</a>  or submit their request by filling out the Google form:<a href="https://forms.gle/EA5uzfGmKEzaeg4P8" target="_blank"> https://forms.gle/EA5uzfGmKEzaeg4P8</a> to get their details changed',
    },
    {
        question:
            "Will I be able to give the exam if the student's PS ID is not created?",
        type: 'text',
        answer: 'Yes, you will be able to give the exam without the PS ID.',
    },
    {
        question:
            'What are the supported browsers & operating systems to write IACST Online?',
        type: 'text',
        answer: '<ul><li>Device Support: Mobile, Desktop, Tablet</li><li>Browser Support: Chrome, Samsung Internet, Safari, Edge, Opera, Firefox.</li><li>OS Support: Android (Android 7 and above), Windows (Windows 7,8,8.1,10, 11), Linux, iOS (iOS 12 and above), MacOS (Mac OS 10 and above)</li><ul><li> Windows 7, 8, 8.1, 10, 11: Preferred Browser - Chrome, Edge, Firefox</li><li>Android OS version (7 and above):Preferred Browser - Chrome, Firefox, Samsung Internet browser for Samsung devices</li><li>MAC OS version 10 & above. Preferred browser - Chrome, Safari</li><li>IOS OS version 12 & above. Preferred browser - Chrome, Safari</li><li>Linux. Preferred browser: Chrome</li></ul></ul>',
    },
    {
        question: 'Student says the IACST Test is not showing on the dashboard.',
        type: 'text',
        answer: 'Please check the your details for which tests are not visible. Main IACST test card will always be visible on the dashboard. The status of the Main IACST card can be<ul><li><strong>Missed</strong> - If you did not give the exam on the intended date</li><li><strong>Upcoming</strong> - If your exam is in the future date</li><li><strong>Start Now</strong> - Status on the day of the test</li><li><strong>Result Awaited</strong> - If you have submitted your test.</li><li><strong>View Result</strong> - If you have submitted your test.</li></ul>',
    },
    {
        question:
            'I want to take IACST Test in Gujarati Language. How can I change the Language?',
        type: 'text',
        answer: 'The iACST Test in Gujarati language is exclusively available in offline mode. To take the test, please visit your nearest Aakash center. In case you need any further assistance, please contact us at the iACST Toll-Free Number: 8800198748, or email us at <a href="mailto:acstsupport@aesl.in">acstsupport@aesl.in</a>.',
    },
    {
        question:
            'What should we do if a student is not able to view questions/images of the test?',
        type: 'text',
        answer: 'Clear the cache, close all the browser tabs and open the test in a new incognito window in chrome browser. The test attempts will remain intact<br/>Steps to clear cache on Chrome<ul><li>On your computer, open Chrome.</li><li>At the top right, click More.</li><li>Click More tools and then Clear browsing data.</li><li>At the top, choose a time range. To delete everything, select All time.</li><li>Next to "Cookies and other site data" and "Cached images and files," check the boxes.</li><li>Click Clear data</li></ul>',
    },
    {
        question: 'What should we do if a student submits the test by mistake?',
        type: 'text',
        answer: 'You call on IACST Toll-Free No. 8800198748 or write on <a href="mailto:acstsupport@aesl.in">acstsupport@aesl.in</a> or submit their request by filling out the Google form: <a href="https://forms.gle/EA5uzfGmKEzaeg4P8" target="_blank">https://forms.gle/EA5uzfGmKEzaeg4P8</a> to get their details changed',
    },
    {
        question: 'Question not appearing by clicking on the next button',
        type: 'text',
        answer: 'Clear the cache, close all the browser tabs and open the test in a new incognito window in chrome browser. The test attempts will remain intact',
    },
    {
        question:
            'What should we do if I student is not able to view questions/images of the test',
        type: 'text',
        answer: 'Clear the cache, close all the browser tabs and open the test in a new incognito window in the chrome browser. The test attempts will remain intact<ul><li>On your computer, open Chrome.</li><li>At the top right, click the three vertical dots.</li><li>Click More tools and then Clear browsing data.</li><li>At the top, choose a time range. To delete everything, select All time.</li><li>Next to "Cookies and other site data" and "Cached images and files," check the boxes.</li><li>Click Clear data.</li><li>Login again to the </li><li>Check the internet connection. The student can write “internet speed test” on google and check the speed. This works for both mobile and desktop. The result should say “Your internet speed is fast or very fast”. PFB the screenshot for your reference. <img src="https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/faq-img.png" alt="pdf-icon" style="width: 100%;margin-top: 10px"/></li></ul>',
    },
]

export const afterTestFAQs = [
    {
        question: 'What courses are available at Aakash?',
        answer: 'Aakash offers courses for medical, and engineering entrance exams and scholarship exams such as NEET, JEE, Olympiads, NTSE and NSEs. You can take admission in one-year, two-year, three-year or four-year courses. You can download the latest prospectus here.<a href="https://aakash.ac.in/prospectus" target=_blank>(https://aakash.ac.in/prospectus).</a>',
        type: 'text',
    },
    {
        question: 'Can I get a scholarship on Aakash courses?',
        answer: 'We conduct scholarship exams throughout the year through which students can avail of scholarships on the course fee. These scholarship exams are completely online and can be taken online from the comfort of your home. You can appear for these scholarship exams in online or offline mode at any of the Aakash branches/centres as well.',
        type: 'text',
    },
    {
        question: 'How do I find an Aakash center?',
        answer: 'Students can refer to the center address and Google map link mentioned above to locate your nearest Aakash center. Students can  also call on the Branch/center contact numbers for more details.',
        type: 'text',
    },
    {
        question:
            'I have some questions regarding courses and the admission process. Can I talk to someone at Aakash?',
        answer: 'You can call us at <a href="tel:1800-102-2727">1800-102-2727</a>. Our admission assistance team will answer all your queries.',
        type: 'text',
    },
]

export const MOCKNEET = [
    {
        question: 'Is the Neet mock test open for all Classes and Streams?',
        answer: 'Any NEET 2025 aspirant can register and appear for the mock test. However, current Aakash students (Aakashians) are not eligible for this test.',
        type: 'text',
    },
    {
        question: 'What are the exam timings?',
        answer: 'The neet mock test timings are 10:00 AM to 1:00 PM',
        type: 'text',
    },
    {
        question:
            'What are the guidelines for appearing in the exam on the same day as registration?',
        answer: 'A student can register on the same day by visiting the nearest branch and appear for the test.',
        type: 'text',
    },
    {
        question: 'What will be the last date for enrollment?',
        answer: 'The last date for enrollment will be 5 days before the exam date.',
        type: 'text',
    },
    {
        question: 'What will be the admit card release date?',
        answer: 'The admit card will be released two days before the exam date.',
        type: 'text',
    },
    {
        question: 'When will the NEET Mock Test result be declared?',
        answer: 'The result declaration date for the NEET Mock Test is 2 days after the exam date (tentative)',
        type: 'text',
    },
    {
        question: 'How should we get the Class/Date/ changed for the student?',
        answer: 'Please visit your nearest Aakash center. In case you need any further assistance, please contact us at the NEET Toll-Free Number 8800013123',
        type: 'text',
    },
    {
        question:
            "Will I be able to give the exam if the student's PSID is not created?",
        answer: 'Yes, you will be able to give the exam without the PSID.',
        type: 'text',
    },
]

export const IAT = [
    {
        question:
            '1. Is the IAT (Invictus Admission Test) open for all Classes and Streams?',
        answer: 'Class 8th to 12th students and 12th Appeared/Passed are eligible to appear for the Invictus Admission Test.',
        type: 'text',
    },
    {
        question: '2. What are the exam timings?',
        answer: 'The IAT (Invictus Admission Test) will be held from 9:00 AM to 5:00 PM in two slots: 9:00 AM to 12:00 PM and 2:00 PM to 5:00 PM.',
        type: 'text',
    },
    {
        question: '3. What will be the last date for enrolment?',
        type: 'text',
        answer: 'The last date for enrolment will be 1 day before the exam date.',
    },
    {
        question: '4. What will be the admit card release date?',
        type: 'text',
        answer: ' The admit card will be released 2 days before the exam date.',
    },
    {
        question:
            '5. When will the IAT (Invictus Admission Test)  result be declared?',
        type: 'text',
        answer: ' The result declaration date for the IAT (Invictus Admission Test) is 5-7 days after the exam date.',
    },
    {
        question: '6. How should we get the Class/Date/ changed for the student?',
        type: 'text',
        answer: ' Please visit your nearest Aakash center. In case you need any further assistance, please contact us at the IAT Toll-Free Number 7303759494 or email at <a href="mailto:support.invictus@aesl.in">support.invictus@aesl.in</a>',
    },
    {
        question:
            '7. Will I be able to give the exam if the student’s PSID is not created?',
        type: 'text',
        answer: ' Yes, you will be able to give the exam without the PSID.',
    },
    {
        question: '8. What would be the Exam Duration for the test ?',
        type: 'text',
        answer: ' The exam duration will be 3 hours',
    },
]

export const JEEMOCK = [
    {
        question: '1. What is JEE ADVANCED MOCK TEST SERIES?',
        answer: 'Aakash JEE ADVANCED MOCK Test Series is an online practice test designed to help JEE (UG) 2025 aspirants assess their preparation. It follows the actual JEE exam pattern, covering Physics, Chemistry, and Maths, and provides an All India Rank (AIR) to help students understand their national-level performance.',
        type: 'text',
    },
    {
        question: '2. Who can participate in the JEE ADVANCED MOCK TEST SERIES?',
        answer: 'Open to all JEE aspirants, including non-Aakash students. Students in Class 12th and 12th passed can participate.',
        type: 'text',
    },
    {
        question: '3. Will the test series be conducted online or offline?',
        answer: 'The Aakash JEE ADVANCED MOCK TEST SERIES will be conducted online.',
        type: 'text',
    },
    {
        question: '4. Is there any registration fee for the test series?',
        answer: 'Yes, candidates can register for ₹200 per test. There are 6 tests in total, making the total cost ₹1200.',
        type: 'text',
    },
    {
        question: '5. What are the exam dates for the test series?',
        answer: 'April 2025: 29th. May 2025: 2nd, 6th, 9th, 13th, and 15th.',
        type: 'text',
    },
    {
        question: '6. What is the exam duration for the tests?',
        answer: 'There are two papers (Paper 1 and Paper 2), each with a duration of 3 hours.',
        type: 'text',
    },
    {
        question: '7. What is the exam timing window?',
        answer: 'The exam starts at 9 AM and remains valid for the next 48 hours.',
        type: 'text',
    },
    {
        question: '8. When will the results be declared?',
        answer: 'The result will be declared 3 days after the exam date.',
        type: 'text',
    },
]
